import { render } from "./Header.vue?vue&type=template&id=c3ac2488&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=c3ac2488&scoped=true&lang=css"

import exportComponent from "/Users/farhanlatif/Code/admin-dashboard/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3ac2488"]])

export default __exports__